// extracted by mini-css-extract-plugin
module.exports = {"container":"ReceiptSender_container_xT8cy"};